import React from "react";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import P1 from "../../assets/img/memberships/TypeA/adb.svg"
import P2 from "../../assets/img/memberships/TypeH/hia.svg"
import P3 from "../../assets/img/memberships/TypeE/ea.svg"
import P4 from "../../assets/img/memberships/TypeB/bdaa.svg"
import Paragraph from "../../components/common/Typography/Paragraph";

const Associations = () => {
  const data = [
    // { pic: P1, name: 'Australian Drainage Association' },
    { pic: P2, name: 'Housing Industry Association' },
    { pic: P3, name: 'Engineers Australia' },
    // { pic: P4, name: 'Building Design Association' },
  ];
  return (
    <>
      <SecondaryHeading
        variant={"MainParagraphHeading"}
        className={"text-offblack mb-4"}
      >
        Membership
      </SecondaryHeading>
      <div className="flex flex-col gap-5 items-start">
        {data.map((e, index) => (
          <a
            key={index}
            href="#"
            className="flex flex-row items-center gap-3 group transition-colors duration-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="w-[50px] h-[50px] object-contain"
              src={e.pic}
              alt="Association logo"
            />
            <Paragraph variant={"BodyCompact"} className="group-hover:text-primaryblue transition-colors duration-200">{e.name}</Paragraph>
          </a>
        ))}
      </div>
    </>
  );
};

export default Associations;
